module.exports = __webpack_public_path__ + "static/media/location-los-angeles.2448008f.jpeg";